// extracted by mini-css-extract-plugin
module.exports = {"wave":"Intro_wave__2x8Zr","wave-animation":"Intro_wave-animation__2UKO3"};